import styled from 'styled-components';

export const FlexCellContent = styled.div`
  padding-block: 20px;
  line-height: 30px;
`;
